var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{style:(`font-size: ${Math.round(_vm.fontSize*0.4)}px`)},[_vm._v("Nos sigue el")]),_c('span',{style:(`font-family: 'Fredericka the Great', cursive !important; font-weight: 300; font-size: ${_vm.fontSize}px; margin-left: ${Math.round(_vm.fontSize*0.15)}px`)},[_vm._v(" pueblo mestizo y originario ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }